/**
 * TeamPresenter
 *
 * @author Dec Norton <decnorton@gmail.com>
 */

import { Presenter } from '../../presenters/presenter';
import { TeamGroupPresenter } from "@app/modules/team-groups/team-group-presenter";

export class TeamPresenter extends Presenter {
    get name() {
        return this.description;
    }

    get description() {
        return this.data.description;
    }

    get is_sage_enabled() {
        return this.data.is_sage_enabled;
    }

    get group() {
        return this._get('group', () => TeamGroupPresenter.create(this.get('group.data')));
    }
}
